"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = void 0;

var _constants = require("./constants");

var validate = function validate(_ref, searchType) {
  var destination = _ref.destination,
      datepicker = _ref.datepicker,
      departure = _ref.departure;
  var errors = {};

  if (!destination) {
    errors.destination = 'Required';
  }

  var isDatepickerDates = Boolean(datepicker && datepicker.left.date && datepicker.right.date);

  if (!isDatepickerDates && destination && searchType !== _constants.SEARCH_TYPE_NAMES.TRIP) {
    errors.datepicker = 'Required';
  }

  if (!departure && destination && isDatepickerDates && searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE) {
    errors.departure = 'Required';
  }

  return errors;
};

exports.validate = validate;